var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('h3',[_vm._v(_vm._s(_vm.$t('general.posArticleNumberList')))]),_c('textarea',{attrs:{"disabled":""},domProps:{"value":_vm.posArticleNumberListWithNewLines}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }